"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOnlineStatusRequest = void 0;
require("isomorphic-fetch");
const url = 'https://screen.omborigrid.com/is-online.json';
const getUrl = () => `${url}?r=${Math.random()}`;
const defaultOptions = {
    checkIntervalMs: 10 * 1000,
};
const requestTimeoutMs = 3 * 1000;
exports.getOnlineStatusRequest = (timeoutMs = requestTimeoutMs) => {
    return new Promise((resolve, reject) => {
        const requestTimeout = setTimeout(() => resolve(false), timeoutMs);
        fetch(getUrl())
            .then((res) => res.json())
            .then((res) => resolve(res.isOnline))
            .catch(() => resolve(false))
            .finally(() => clearTimeout(requestTimeout));
    });
};
class OnlineStatusSubscription {
    constructor(options) {
        this.activatedAt = null;
        this.listeners = [];
        this.isOnline = null;
        this.getOnlineStatus = () => {
            return exports.getOnlineStatusRequest();
        };
        this.pollOnlineStatus = () => {
            const startActivatedAt = this.activatedAt;
            this.getOnlineStatus()
                .then((currentStatus) => {
                if (this.activatedAt && startActivatedAt === this.activatedAt) {
                    if (this.isOnline !== currentStatus) {
                        this.isOnline = currentStatus;
                        this.emit(currentStatus);
                    }
                }
            })
                .catch((err) => {
                // this is not expected, there should be no error from the function
                console.error(`Error getting online status: ${err}`);
            })
                .finally(() => {
                if (this.activatedAt && startActivatedAt === this.activatedAt) {
                    this.onlineCheckTimeout = setTimeout(this.pollOnlineStatus, this.options.checkIntervalMs);
                }
            });
        };
        this.start = () => {
            if (!this.activatedAt) {
                this.activatedAt = Date.now();
                this.pollOnlineStatus();
            }
        };
        this.stop = () => {
            if (this.onlineCheckTimeout) {
                clearTimeout(this.onlineCheckTimeout);
            }
            this.activatedAt = null;
        };
        this.emit = (status) => {
            for (const listener of this.listeners) {
                listener(status);
            }
        };
        this.subscribe = (listener) => {
            this.listeners = this.listeners.concat([listener]);
            return () => this.unsubscribe(listener);
        };
        this.unsubscribe = (listener) => {
            this.listeners = this.listeners.filter((activeListener) => activeListener !== listener);
        };
        this.options = Object.assign(Object.assign({}, defaultOptions), options);
    }
}
exports.default = OnlineStatusSubscription;
